





























































import Vue, {PropOptions} from 'vue';
import {KernelPart, KernelPartListParameter} from '@roomle/web-sdk/lib/definitions/typings/kernel';
import HeightToggle from '@/configurator/components/utils/HeightToggle.vue';
import {formatPrice, normalizeFloatingNumber} from '@/common/utils/helper';
import {Nullable} from '@/common/utils/types';
import {prepareParametersForUi} from '@/common/utils/parameters';

import {CORE_DATA_GETTERS} from '@/configurator/store/core-data';
import {getGeneralCustomConfig, getFieldCustomConfigByKey} from '@/common/utils/custom-config';

export default Vue.extend({

  components: {
    HeightToggle,
  },

  props: {
    part: Object as PropOptions<KernelPart>,
  },

  computed: {
    showsPrices(): boolean {
      return this.$store.getters[CORE_DATA_GETTERS.SHOWS_PART_LIST_PRICES];
    },
    parametersToShow(): KernelPartListParameter[] {
      return prepareParametersForUi(this.part.parameters);
    },
    price(): Nullable<string> {
      const article: any = this.articleBySku(this.part.articleNr);

      if (article) {
        return formatPrice(this.$store.state.coreData.currencySymbol, article.price * this.part.count + (article.fixed_price ? article.fixed_price : 0));
      }

      return formatPrice(this.part.currencySymbol, this.part.price);
    },
    fullPrice() {
      let {price} = this.$store.state.coreData;

      price = new Intl.NumberFormat('de-DE').format(price);

      const priceWithCurrency = `${this.$store.state.coreData.currencySymbol} ${price}`;
      return priceWithCurrency;
    },
    count(): number {
      return normalizeFloatingNumber(this.part.count);
    },
    noParameters(): boolean {
      return this.parametersToShow.length === 0;
    },
    title(): Nullable<string> {
      const article: any = this.articleBySku(this.part.articleNr);
      if (article && article.title) {
        return article.title;
      } else if (article && article.webshop_title) {
        return article.webshop_title;
      }
      return this.part.label;
    },
    description(): Nullable<string> {
      const article: any = this.articleBySku(this.part.articleNr);
      if (article && article.short_description) {
        return article.short_description;
      } else if (article && article.web_teaser) {
        return article.web_teaser;
      }
      return '';
    },
  },

  methods: {
    articleBySku(sku: string): string {
      const articles = this.$store.getters[CORE_DATA_GETTERS.ARTICLES];
      const filtered = articles.filter((article: any) => article.sku === sku);
      return filtered.length > 0 ? filtered[0] : null;
    },
    getLook(): string {
      return getGeneralCustomConfig().look;
    },
    getFilteredParams(parameter: any): string|undefined {
      const articlesWithParams = [
        '2500-120-A-01-705',
      ];
      if (!articlesWithParams.includes(this.part.articleNr)) { return; }
      let params = parameter.map((param: any) => {
        if (
          param.key === 'basinsCount'
          || param.key === 'setWidth'
          || param.key === 'setDepth'
          || param.key === 'model'
        ) {
          return `${getFieldCustomConfigByKey(param.key).label || param.label}: ${param.valueLabel}`;
        }
      });
      params = params.filter((param: string) => !!param);
      return `Gewählte Konfiguration: ${params.join(', ')}`;
    },
  },

});
